import { React } from 'react';
import HeroSlider from '../Slider/HeroSlider';
import { useLanguage } from '../../contexts/LanguageContext';

const Hero = ({ data }) => {
  const { t } = useLanguage();
  const bgImg = data.bgImg;
  const bgShape = data.bgShape;
  const sliderImages = data.sliderImages;

  return (
    <div
      id="home"
      className="st-hero-wrap st-gray-bg st-dynamic-bg overflow-hidden st-fixed-bg"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="st-hero st-style1">
        <div className="container">
          <div className="st-hero-text">
            <div className="st-height-b40 st-height-lg-b40" />
              <h1 className="st-hero-title cd-headline slide st-responsive-title">
                {t('hero.mainTitle')} <br />
              </h1>
              <div className="st-hero-subtitle" 
              style={{ maxWidth: '750px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                {t('hero.subtitle')}
              </div>
            <div className="st-hero-btn">

            </div>
          </div>
        </div>
        <div className="st-hero-social-group">
          <div className="container">
            {/* <Social /> */}
          </div>
        </div>
      </div>
      <HeroSlider data={sliderImages} />
      <div className="st-hero-shape">
        <img src={bgShape} alt={bgShape} />
      </div>
    </div>
  );
};

export default Hero;